export const skills = [
    {
        title: 'Languages',
        icon: 'code',
        skills: [
            'JavaScript (ES6+)',
            'TypeScript',
            'HTML5',
            'CSS3',
            'PHP',
            'SQL',
        ],
    },
    {
        title: 'Frontend',
        icon: 'react',
        skills: [
            'React',
            'Next.js',
            'Vue.js',
            'Nuxt.js',
            'Angular',
            'AngularJS',
            'React Native',
        ],
    },
    {
        title: 'Architecture',
        icon: 'cube',
        skills: [
            'Micro Frontends (single-spa)',
            'Module Federation',
            'Design Systems',
        ],
    },
    {
        title: 'Accessibility',
        icon: 'universal access',
        skills: [
            'WCAG',
            'ARIA',
            'Semantic HTML',
        ],
    },
    {
        title: 'State Management',
        icon: 'random',
        skills: [
            'Redux',
            'Redux Saga',
            'Vuex',
            'Context API',
        ],
    },
    {
        title: 'Backend & APIs',
        icon: 'server',
        skills: [
            'Node.js',
            'Express',
            'REST APIs',
            'GraphQL (Apollo Client)',
            'Firebase Realtime Database',
        ],
    },
    {
        title: 'Styling',
        icon: 'paint brush',
        skills: [
            'Sass',
            'Less',
            'Material UI',
            'Ant Design',
            'Bootstrap',
            'Semantic UI',
        ],
    },
    {
        title: 'Testing',
        icon: 'check circle outline',
        skills: [
            'Jest',
            'React Testing Library',
            'MSW',
            'Cypress',
            'Pact',
            'Selenium',
            'Jasmine',
            'Protractor',
            'SonarQube',
        ],
    },
    {
        title: 'Build & CI/CD',
        icon: 'cogs',
        skills: [
            'Webpack',
            'NPM',
            'Yarn',
            'Docker',
            'Jenkins',
            'Bamboo',
        ],
    },
    {
        title: 'CMS',
        icon: 'file code outline',
        skills: [
            'Adobe Experience Manager (AEM)',
            'Kentico',
        ],
    },
    {
        title: 'PHP Stack',
        icon: 'php',
        skills: [
            'Laravel',
            'CodeIgniter',
            'Symfony',
            'WordPress',
            'MySQL',
        ],
    },
    {
        title: 'AI Tools',
        icon: 'magic',
        skills: [
            'ChatGPT',
            'Claude Code',
            'GitHub Copilot',
            'Prompt Engineering',
        ],
    },
    {
        title: 'Tools & Collaboration',
        icon: 'wrench',
        skills: [
            'Storybook',
            'Git',
            'ESLint',
            'Prettier',
            'Jira',
            'Confluence',
            'Figma',
            'Adobe XD',
            'Microsoft Teams',
            'Slack',
            'Google Tag Manager',
        ],
    },
    {
        title: 'Engineering Practices',
        icon: 'settings',
        skills: [
            'Clean Code',
            'Reusable Components',
            'Automated Testing',
            'Code Reviews',
            'CI/CD',
            'Agile (Scrum & Kanban)',
        ],
    },
    {
        title: 'Analytics & Experimentation',
        icon: 'chart line',
        skills: [
            'Amplitude Analytics',
            'A/B Testing',
            'Data-Driven Decision Making',
        ],
    },
];



// WEBPACK FOOTER //
// ./src/components/Skills/Skills.data.js